import { TestMessageFilter } from 'models/message-content.model';

const queryKeys = {
    messageContent: (id: string) => ['message-content', id] as const,
    messageContentCount: (
        id: string,
        formula_id?: number,
        filters?: TestMessageFilter,
    ) => ['message-content-count', id, formula_id, filters] as const,
};

export default queryKeys;
